import _defineProperty from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { dsnToString, createEnvelope } from '@sentry/utils';
/**
 * Creates an envelope from a user feedback.
 */

function createUserFeedbackEnvelope(feedback, _ref) {
  var metadata = _ref.metadata,
      tunnel = _ref.tunnel,
      dsn = _ref.dsn;

  var headers = _objectSpread({
    event_id: feedback.event_id,
    sent_at: new Date().toISOString()
  }, metadata && metadata.sdk && {
    sdk: {
      name: metadata.sdk.name,
      version: metadata.sdk.version
    }
  }, {}, !!tunnel && !!dsn && {
    dsn: dsnToString(dsn)
  });

  var item = createUserFeedbackEnvelopeItem(feedback);
  return createEnvelope(headers, [item]);
}

function createUserFeedbackEnvelopeItem(feedback) {
  var feedbackHeaders = {
    type: 'user_report'
  };
  return [feedbackHeaders, feedback];
}

export { createUserFeedbackEnvelope };